<template>
    <div class="border-b border-theme-border w-full pb-4">
        <div class="w-full flex justify-between items-center">
            <div class="flex lg:flex-row flex-col">
                <div>
                    <strong>Código de barras {{ inventory.barcode }}</strong>
                </div>
            </div>
            <div class="flex items-center">
                <app-button icon border circle @click="toggleActive">
                    <ChevronUpIcon v-if="isActive" class="w-5 h-5" />
                    <ChevronDownIcon v-else class="w-5 h-5" />
                </app-button>
                <div v-if="enabled" id="actions" class="flex">
                    <app-button danger icon @click="remove">🗑</app-button>
                </div>
            </div>
        </div>
        <custom-collapse
            ref="container mx-auto"
            :visible="isActive"
            class="flex flex-wrap"
        >
            <div
                class="lg:w-2/12 md:w-1/4 w-4/12 flex justify-center items-center py-3"
            >
                <div class="w-28 h-28 p-0">
                    <img
                        v-img-loading
                        class="w-full h-full"
                        :src="inventory.images[0].url | image"
                        :alt="inventory.images[0].alt"
                        loading="lazy"
                    />
                </div>
            </div>
            <div
                class="lg:w-10/12 md:w-3/4 w-8/12 flex flex-col justify-around py-3 px-1"
            >
                <div>
                    <div class="w-full flex justify-between mb-3">
                        <div class="flex flex-col">
                            <router-link
                                :to="`/app/products/detail/${inventory.productId}`"
                                class="btn-a p-0"
                            >
                                <span class="h4 text-center">
                                    {{ inventory.name }}
                                </span>
                            </router-link>
                            <small>
                                Prod
                                <router-link
                                    :to="`/app/products/detail/${inventory.productId}`"
                                    class="btn-a p-0"
                                >
                                    {{ inventory.productId }}
                                </router-link>
                                | ID
                                <router-link
                                    :to="`/app/products/detail/${inventory.productId}?reference=${inventory.id}&tab=references`"
                                    class="btn-a p-0"
                                >
                                    {{ inventory.id }}
                                </router-link>
                                {{
                                    inventory.barcode
                                        ? ` | Cód ${inventory.barcode}`
                                        : ""
                                }}
                            </small>
                        </div>
                        <div class="flex flex-col">
                            <span>Color : {{ inventory.color }}</span>
                            <span>Tamaño : {{ inventory.size }}</span>
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap mb-3">
                    <div class="w-1/2 flex flex-col">
                        <span class="text-theme-primary">
                            Precio de venta global actual
                        </span>
                        <span>
                            {{
                                inventoryComponent.currentGlobalPriceOffer
                                    | money
                            }}
                        </span>
                    </div>
                    <div
                        v-if="
                            isOfferPrice(
                                inventoryComponent.currentGlobalPrice,
                                inventoryComponent.currentGlobalPriceOffer
                            )
                        "
                        class="w-1/2 flex flex-col"
                    >
                        <span class="text-theme-primary">
                            Precio anterior global actual
                        </span>
                        <span>
                            {{ inventoryComponent.currentGlobalPrice | money }}
                        </span>
                    </div>
                    <div class="w-1/2 flex flex-col">
                        <span class="text-theme-primary">
                            Identificadores
                        </span>
                        <span>
                            Código de barras
                            {{ inventoryComponent.barcode }} | SKU
                            {{ inventoryComponent.sku }}
                        </span>
                    </div>
                    <div class="w-1/2 flex flex-col">
                        <span class="text-theme-primary">
                            Última actualización de referencia
                        </span>
                        <span>
                            {{ inventory.updatedAt | date }}
                        </span>
                    </div>
                    <div
                        v-if="inventory.currentUnits"
                        class="w-1/2 flex flex-col"
                    >
                        <span class="text-theme-primary"> Stock actual </span>
                        <span>
                            {{ inventory.currentUnits }}
                        </span>
                    </div>
                    <div
                        v-if="inventory.currentCost"
                        class="w-1/2 flex flex-col"
                    >
                        <span class="text-theme-primary"> Costo actual </span>
                        <span>
                            {{ inventory.currentCost | money }}
                        </span>
                    </div>
                    <div
                        v-if="inventoryComponent.currentPriceOffer"
                        class="w-1/2 flex flex-col"
                    >
                        <span class="text-theme-primary">
                            Precio de venta actual
                        </span>
                        <span>
                            {{ inventoryComponent.currentPriceOffer | money }}
                        </span>
                    </div>
                    <div
                        v-if="
                            isOfferPrice(
                                inventoryComponent.currentPrice,
                                inventoryComponent.currentPriceOffer
                            )
                        "
                        class="w-1/2 flex flex-col"
                    >
                        <span class="text-theme-primary">
                            Precio anterior actual
                        </span>
                        <span>
                            {{ inventoryComponent.currentPrice | money }}
                        </span>
                    </div>
                    <div class="w-full lg:w-1/2 mt-5">
                        <custom-input
                            v-model="inventoryComponent.stock"
                            min="1"
                            type="number"
                            label="Stock"
                            :disabled="!enabled"
                            @focus="onFocus"
                            @blur="updateItem"
                        />
                    </div>
                    <div class="w-full mt-5">
                        <price-offer-fields
                            v-model="prices"
                            :enabled="enabled"
                            @blur="updateItem"
                        />
                    </div>
                </div>
            </div>
        </custom-collapse>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { isOfferPrice } from "@/common/lib/price-offer";

import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon.vue";
import CustomCollapse from "@/components/utils/CustomCollapse.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import PriceOfferFields from "@/components/utils/PriceOfferFields.vue";

export default {
    name: "InventoryManage",
    components: {
        PriceOfferFields,
        CustomCollapse,
        CustomInput,
        ChevronDownIcon,
        ChevronUpIcon
    },
    props: {
        inventory: {
            type: Object,
            required: true,
            default: () => ({
                barcode: "null",
                cost: 0,
                stock: 0
            })
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["update", "remove"],
    data: () => ({
        inventoryComponent: {
            barcode: "",
            cost: 0,
            stock: 0
        },
        isActive: false
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        prices: {
            get() {
                return {
                    price: this.inventoryComponent.price,
                    priceOffer: this.inventoryComponent.priceOffer,
                    cost: this.inventoryComponent.cost
                };
            },
            set({ cost, price, priceOffer }) {
                this.inventoryComponent = {
                    ...this.inventoryComponent,
                    price,
                    priceOffer,
                    cost
                };
            }
        }
    },
    watch: {
        inventory(value) {
            this.setInventory(value);
        }
    },
    mounted() {
        this.setInventory(this.inventory);
    },
    methods: {
        isOfferPrice,
        remove() {
            this.$emit("remove", { barcode: this.inventory.barcode });
        },
        updateItem() {
            this.$emit("update", this.inventoryComponent);
        },
        setInventory(inventory) {
            this.inventoryComponent = {
                ...inventory
            };
        },
        toggleActive() {
            this.isActive = !this.isActive;
        },
        onFocus() {
            this.$emit("focus");
        }
    }
};
</script>
